import Vue from 'vue';
import SvgIcon from './svgIcon';
import layout from './layout';
import './ztree/css/zTreeStyle.css';
import './ztree/css/schema-tree-plus.scss';

Vue.component('svg-icon', SvgIcon);
Vue.component('layout', layout);
